<template>
	<div class="flex w-full justify-center px-8 sm:px-20 py-32 md:py-12">
		<div class="w-full max-w-2xl lg:max-w-4xl text-ihh-slate-gray space-y-6 text-base">
			<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-4xl text-start">Sitemap - Categories</div>
			<div class="">
				<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-3xl text-start">Categories</div>
				<ul>
					<template v-for="category in categories">
						<li class="list-disc">
							<a :href="`/categories${category.url}`" class="link">{{ category.name }}</a>
							<template v-if="category.subCategories.length > 0">
								<ul class="list-disc pl-6">
									<li v-for="subCategory in category.subCategories">
										<a :href="`/categories${subCategory.url}`" class="link">{{ subCategory.name }}</a>
										<template v-if="subCategory.subCategories.length > 0">
											<ul class="list-disc pl-6">
												<li v-for="subCategory in subCategory.subCategories">
													<a :href="`/categories${subCategory.url}`" class="link">{{ subCategory.name }}</a>
												</li>
											</ul>
										</template>
									</li>
								</ul>
							</template>
						</li>
					</template>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'SitemapCategories',
	inject: ['store'],
	data() {
		return {
			categories: [],
			excludedCategories: [158, 160, 161, 162],
		}
	},
	async created() {
		const categories = await axios.get(`${this.store.api}/controllers/bigCommerce/categories`)
		this.categories = categories.data.filter((c) => !this.excludedCategories.includes(c.bcId))
	},
}
</script>

<style scoped>
.link {
	@apply text-ihh-dark-salmon hover:text-ihh-salmon font-semibold underline;
}
</style>
